<!-- Header -->
<section class="page__header">
    <custom-app-bar
            [title]="(data$ | async)?.title"
            [hasCloseButton]="true"
            [hasSafeArea]="false"
    >
    </custom-app-bar>
</section>

<!-- Content -->
<section class="page__content">
    <p class="message">{{ (data$ | async)?.message }}</p>
    <div class=action-buttons>

        <!-- Accept button -->
        <button
                customButton
                size="large"
                expand="full"
                (click)="handleOnClickAcceptAction()"
        >
            {{ (data$ | async)?.acceptButtonText }}
        </button>

        <!-- Cancel button -->
        <button
                customButton
                size="large"
                expand="full"
                appearance="ghost"
                (click)="handleOnClickCancelAction()"
        >
            {{ (data$ | async)?.cancelButtonText }}
        </button>

    </div>
</section>